// extracted by mini-css-extract-plugin
module.exports = {"WelcomePic":"WelcomePage_WelcomePic__-90UD"};